<template>
  <div class="card card-custom card-stretch gutter-b setting-item">
    <!--begin::Header-->
    <div class="card-header align-items-center">
      <h3 class="card-title align-items-start flex-column">
        <span class="title font-weight-bold">
          {{ i18n.fan }}
        </span>
      </h3>
      <div class="card-toolbar toolbar-symbol">
        <a href="#" class="btn btn-icon btn-hover-light-primary draggable-handle">
          <i class="ki ki-menu"></i>
        </a>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div v-show="controllerType !== '코모로'" class="card-body">
      <!--begin::form-group-->
      <div class="form-group row">
        <label class="col-form-label col-12 col-lg-6">
          <span class="font-weight-normal">{{ i18n.startTime }}</span>
        </label>
        <div class="col-12 col-lg-6">
          <b-form-timepicker v-if="this.controllerType == '제닉스'" v-model="fanStarttimeHm" size="sm" locale="en-us" class="mb-2 genix" minutes-step="60" @input="conveyTime"></b-form-timepicker>
          <b-form-timepicker v-else v-model="fanStarttimeHm" size="sm" locale="en-us" class="mb-2" @input="conveyTime"></b-form-timepicker>
        </div>
      </div>
      <!--end::form-group-->
      <!--begin::form-group-->
      <div class="form-group row">
        <label class="col-form-label col-12">
          <span class="font-weight-normal">{{ i18n.operationTime }} : {{fanDurationHh}}{{i18n.hour}}</span>
        </label>
        <div class="col-12">
          <template>
            <div class="custom-range-slider">
              <b-form-input id="range-2" v-model="fanDurationHh" type="range" min="0" max="24" step="1" @change="conveyData('fanDurationHh')"></b-form-input>
              <div class=" d-flex justify-content-between">
                <span class="text">0</span>
                <span class="text">3</span>
                <span class="text">6</span>
                <span class="text">9</span>
                <span class="text">12</span>
                <span class="text">15</span>
                <span class="text">18</span>
                <span class="text">21</span>
                <span class="text">24</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!--end::form-group-->
      <!--begin::form-group-->
      <div v-if="this.controllerType == '제어기4'">
        <div class="form-group row">
          <label class="col-form-label col-12 col-lg-6">
            <span class="font-weight-normal">{{ i18n.interval }}</span>
          </label>
          <div class="col-12 col-lg-6">
            <b-form-spinbutton v-model="fanInterval" min="0" max="10000" size="sm" step="1" @change="conveyData('fanInterval')"></b-form-spinbutton>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-form-label col-12 col-lg-6">
            <span class="font-weight-normal">{{ i18n.duration }}</span>
          </label>
          <div class="col-12 col-lg-6">
            <b-form-spinbutton v-model="fanDuration" min="0" max="10000" size="sm" step="1" @change="conveyData('fanDuration')"></b-form-spinbutton>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->

    <!--begin::Body-->
    <div v-show="controllerType === '코모로'" class="card-body">
      <!--begin::form-group-->
      <div class="form-group row">
        <label class="col-form-label col-12">
          <span class="font-weight-normal">{{ i18n.duration }}</span>
        </label>
        <div class="col-12 d-flex justify-content-center">
           <knob-control
              v-model="fan"
              :min="0"
              :stepSize="5"
              :max="60"
           ></knob-control>
        </div>
      </div>
      <!--end::form-group-->
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import KnobControl from 'vue-knob-control';
import { debounce } from 'vue-debounce'
import {syncObj3} from '@/core/services/funcs';
import i18n from '@/core/plugins/vue-i18n.js';

export default {
  name: "Setting7",
  components: {
    KnobControl
  },
  props: {
    elementObj: Object,
    mutateValue: Function,
    effectValue: Number,
    controllerType: String
  },
  watch: {
    effectValue(){
      if(this.elementObj) {
        syncObj3(this.elementObj, this)
        this.fanDurationHh = this.elementObj.fanDurationHh
        if(this.elementObj.fanStarttimeHh !== undefined || this.elementObj.fanStarttimeMm !== undefined) {
          this.fanStarttimeHm = [(this.elementObj.fanStarttimeHh || '00'), (this.elementObj.fanStarttimeMm || '00'), '00'].join(':')
        }else{
          this.fanStarttimeHm = ''
        }
      }
    },
    fan(){
      this.debouncedConveyData()
    }
  },
  data() {
    return {
      fan: 0,
      debouncedConveyData: null,
      fanStarttimeHm : '',
      fanDurationHh : 0,
      fanInterval : 0,
      fanDuration : 0,
      i18n: {
        fan: i18n.t('cultivationEnvControlSetting.fan'),
        startTime: i18n.t('cultivationEnvControlSetting.startTime'),
        operationTime: i18n.t('cultivationEnvControlSetting.operationTime'),
        duration: i18n.t('cultivationEnvControlSetting.duration'),
        interval: i18n.t('cultivationEnvControlSetting.interval'),
        hour: i18n.t('cultivationEnvControlSetting.hour')
      }
    }
  },
  created() {
    this.debouncedConveyData = debounce(this.conveyDataFan, 500)
  },
  methods: {
    conveyDataFan() {
      this.mutateValue('fan', 'fan', this.fan)
    },
    conveyTime(){
      if(this.fanStarttimeHm){
        const starttimeList = this.fanStarttimeHm.split(':');
        if(starttimeList && starttimeList.length === 3) {
          this.mutateValue('fan', 'fanStarttimeHh', starttimeList[0]);
          this.mutateValue('fan', 'fanStarttimeMm', starttimeList[1]);
        }
      }
    },
    conveyData(key){
      this.mutateValue('fan', key, this[key]);
    }
  }
};
</script>
